import { useCallback } from 'react'
import { useDynamicConfig } from '../statsig/useDynamicConfig'

export type IsStablecoinFn = (symbol: string) => boolean

export function useIsStablecoin(): IsStablecoinFn {
  const stablecoinSymbols = useDynamicConfig('stablecoinsymbols')
  return useCallback(
    (symbol: string) =>
      stablecoinSymbols.some((stable) =>
        symbol.toLowerCase().includes(stable.toLowerCase()),
      ),
    [stablecoinSymbols],
  )
}
